import { defineAsyncComponent } from "vue";

export default {
    sectionContainer: defineAsyncComponent(() => import("./SectionContainer.vue")),
    webButton: defineAsyncComponent(() => import("./WebButton.vue")),
    heroContent: defineAsyncComponent(() => import("./HeroContent.vue")),
    card: defineAsyncComponent(() => import("./Card.vue")),
    // Draksy's own admin-app visual identity ("Nightwatch": navy gradient,
    // moonlit-paper surfaces, ember accent), reused here for the marketing
    // site. Locked to Draksy's own tenant (see WEB_THEMES in tokyo-ui's
    // src/classes/webThemes.js) so, unlike every other theme in this
    // registry, its components hardcode the palette instead of reading
    // colors/--brand-* — there is no second tenant to keep it flexible for.
    //
    // Typography mirrors the admin app exactly (Bricolage Grotesque for
    // display/headings, Public Sans for body — see tokyo-ui's src/main.js
    // and tailwind.config.js `fontFamily`), self-hosted via each of this
    // theme's own component files (not a Google Fonts CDN link and not
    // registry.js, which is imported eagerly for every theme) so the font
    // files only ship when nightwatch is the page's active theme.
    tokens: {
        "--theme-font-family": "'Public Sans', ui-sans-serif, system-ui, sans-serif",
        "--theme-font-family-display": "'Bricolage Grotesque Variable', 'Public Sans', ui-sans-serif, system-ui, sans-serif",
        "--theme-tracking": "-0.01em",
        "--theme-text-heading": "#10233e",
        "--theme-text-body": "#17375d",
        "--theme-text-muted": "#4a6b8a",
    },
};
